export default {
      id: "i-ipo-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-ipo",
      toString: function () {
        return this.url;
      }
    }